import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero" id='hero'>
      <h1>Streamline Your HR Processes with Ease</h1>
      <h3>Your Partner in Employee Management and Development</h3>
      <button>Learn More</button>
    </section>
  );
};

export default HeroSection;
